import head from 'lodash/head';
export const getSelectedMarketingChannelOptions = (privacyConsentState) => {
    return Object.entries(privacyConsentState)
        .reduce((acc, item) => {
        if (item?.at(-1)) {
            switch (head(item)) {
                case 'marketingChannelEmail':
                    acc.push('email');
                    break;
                case 'marketingChannelPhone':
                    acc.push('phone');
                    break;
                case 'marketingChannelPaperMail':
                    acc.push('paperMail');
                    break;
                case 'marketingPushNotification':
                    acc.push('pushNotification');
                    break;
            }
        }
        return acc;
    }, [])
        .join(',');
};
